// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Jf3S","rightAdornment":"Header_rightAdornment__3EUAA"};